import React from "react";
import { Route, Redirect } from "react-router-dom";
import Equipment from "./pages/equipment/Router";
import Business from "./pages/business/Router";
import Tenant from "./pages/tenant/Router";
import CapitalAccount from "./pages/capitalAccount/Router";
import Earnings from "./pages/Earnings/Router";
import Employee from "./pages/employee/Router";
import DataAnalysis from "./pages/dataanalysis/Router";
import Version from "./pages/version/Router";
import AuthRoute from "./components/AuthRoute";
import UserAccount from "./pages/userAccount";
import Ssry from "./pages/ssry/router";
import Brand from "./pages/brand/Router";
import { Switch, withRouter } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Operation from "./pages/operation/Router";

const Router = ({ location }) => {
  return (
    <TransitionGroup className={"router-wrapper"}>
      <CSSTransition timeout={1000} classNames={"fade"} key={location.pathname}>
        <Switch location={location}>
          <Route
            path="/page"
            exact
            render={() => (
              <Redirect to="/page/equipment/retailequipment"></Redirect>
            )}
          ></Route>
          <AuthRoute path="/page/equipment" component={Equipment}></AuthRoute>
          <AuthRoute path="/page/operating" component={Operation}></AuthRoute> 
          <AuthRoute path="/page/ssry" component={Ssry}></AuthRoute>
          <AuthRoute path="/page/tenant" component={Tenant}></AuthRoute>
          <AuthRoute path="/page/business" component={Business}></AuthRoute>
          <AuthRoute
            path="/page/capitalaccount"
            component={CapitalAccount}
          ></AuthRoute>
          <AuthRoute path="/page/earnings" component={Earnings}></AuthRoute>
          <AuthRoute path="/page/employee" component={Employee}></AuthRoute>
          <AuthRoute
            path="/page/dataanalysis"
            component={DataAnalysis}
          ></AuthRoute>
          <AuthRoute path="/page/version" component={Version}></AuthRoute>
          <AuthRoute path="/page/brand" component={Brand}></AuthRoute> 
          <AuthRoute
            path="/page/userAccount"
            component={UserAccount}
          ></AuthRoute>
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};
export default withRouter(Router);
